{
  "hero": {
    "title": "Services",
    "cta": "Get in touch"
  },
  "banner": {
    "message": "I am here for any questions",
    "cta": "Get in touch"
  },
  "services": [
    {
      "number": "01",
      "title": "Video and photography content production",
      "description": "The missing link in modern business. I produce high-quality video and photography that most agencies expect you to provide yourself. I design your website around the content I shoot.",
      "items": [
        {
          "title": "Brand stories",
          "description": "Cinematic videos that humanize your company."
        },
        {
          "title": "Product demo and explainer videos",
          "description": "Making complex tech easy to understand."
        },
        {
          "title": "Asset libraries",
          "description": "A monthly bank of professional photos and short-form video (Reels/TikTok) to keep your social media active."
        }
      ]
    },
    {
      "number": "03",
      "title": "Brand engineering",
      "description": "From the first sketch to the final deploy. I don't believe in \"disconnected\" branding. I build your visual identity and your digital storefront as a single, living organism.",
      "items": [
        {
          "title": "Identity design",
          "description": "Logos, typography, and brand books that translate to the web."
        },
        {
          "title": "High-performance web development",
          "description": "Custom-coded websites built for conversion and speed."
        },
        {
          "title": "Digital ecosystems",
          "description": "Ensuring your brand feels the same on a smartphone as it does on a desktop."
        }
      ]
    },
    {
      "number": "02",
      "title": "Strategic UI/UX consultancy",
      "description": "For complex platforms and tech-driven companies. With 20 years of experience, I provide high-level technical leadership for large-scale projects.",
      "items": [
        {
          "title": "Interface audits",
          "description": "Identifying friction points in complex user journeys."
        },
        {
          "title": "Design systems",
          "description": "Building scalable Figma-to-Code libraries (React/Vue)."
        },
        {
          "title": "Architecture and performance",
          "description": "Ensuring your frontend is as fast as it is beautiful."
        }
      ]
    }
  ]
}
